// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostApi } from "../../../ApiClient/PostApi";
import Header from "../layout/Header";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import useFetch from "../../../ApiClient/GetApi";
import { useParams } from "react-router-dom";
import { Facebook } from "react-content-loader";
import Loader from "../../loader/Loader";
export default function UpdateProfile() {
  const { data, reFetch } = useFetch("users/get_profile");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    province: "",
    address: "",
    postalCode: "",
    company: "",
    country: "",
    customCode: "",
    scheduleId: "",
  });

  useEffect(() => {
    if (data) {
      setFormData({
        firstName: data?.data?.user?.firstName ?? "",
        lastName: data?.data?.user?.lastName ?? "",
        email: data?.data?.user?.email ?? "",
        phone: data?.data?.user?.phone ?? "",
        city: data?.data?.user?.city ?? "",
        province: data?.data?.user?.province ?? "",
        address: data?.data?.user?.address ?? "",
        postalCode: data?.data?.user?.postalCode ?? "",
        company: data?.data?.user?.company ?? "",
        country: data?.data?.user?.country ?? "",
        customCode: data?.data?.user?.customCode ?? "",
        scheduleId: data?.data?.user?.scheduleId ?? "",
      });
    }
  }, [data]);

  const [loading, setLoading] = useState(false);
  const onChange = (e) => {
    if (e.target.name === "phone") {
      if (isNaN(e.target.value)) {
        error_toaster("Please enter a number!");
        return false;
      }
    }
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const update_profile = async (event) => {
    event.preventDefault();

    if (formData.firstName === "") {
      error_toaster("First Name is required");
      return false;
    }
    if (formData.lastName === "") {
      error_toaster("Last Name is required");
      return false;
    }

    if (formData.email === "" || formData.email === null) {
      error_toaster("Email is required");
      return false;
    }
    if (formData.phone === "" || formData.phone === null) {
      error_toaster("Phone No. is required");
      return false;
    }

    setLoading(true);
    const res = await PostApi("users/update_profile", {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      city: formData.city,
      province: formData.province,
      address: formData.address,
      postalCode: formData.postalCode,
      company: formData.company,
      country: formData.country,
      customCode: formData.customCode,
      scheduleId: formData.scheduleId,
    });

    if (res.data.status === "1") {
      setLoading(false);
      success_toaster(res.data.message);
      reFetch();
      localStorage.setItem("firstName", res.data.data.firstName);
      localStorage.setItem("lastName", res.data.data.lastName);
    } else {
      setLoading(false);
      success_toaster(res.data.message);
    }
  };
  const body = "body {background: #FFFFFF !important}";
  const inputStyle =
    "bg-themeGray border-none font-normal sm:text-xl text-lg px-5 py-3 rounded-lg placeholder:text-black placeholder:text-opacity-40 focus:outline-none";
  return (
    <>
      <style>{body}</style>
      <Header />
      <section className="flex items-center h-[100vh]">
        {loading ? (
          <Facebook className="px-96" height={550} />
        ) : (
          <div className="xl:w-1/2 lg:w-3/4 md:w-1/2 sm:w-2/3 w-4/5 mx-auto flex flex-col justify-center gap-y-8">
            <h1 className="font-bold sm:text-5xl text-4xl">Update Profile</h1>
            <div className="grid grid-cols-2 gap-y-6 gap-x-4">
              <div className="flex flex-col">
                <label>First Name</label>
                <input
                  value={formData.firstName}
                  onChange={onChange}
                  type="text"
                  name="firstName"
                  placeholder={data?.data?.user?.firstName ?? "First Name"}
                  className={inputStyle}
                  maxLength={15}
                  minLength={5}
                />
              </div>

              <div className="flex flex-col">
                <label>Last Name</label>
                <input
                  value={formData.lastName}
                  onChange={onChange}
                  type="text"
                  name="lastName"
                  placeholder={data?.data?.user?.lastName ?? "Last Name"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Email</label>
                <input
                  value={formData.email}
                  onChange={onChange}
                  type="text"
                  name="email"
                  placeholder={data?.data?.user?.email ?? "Email"}
                  className={inputStyle}
                  maxLength={25}
                />
              </div>
              <div className="flex flex-col">
                <label>Phone</label>
                <input
                  maxLength={15}
                  max={15}
                  value={formData.phone}
                  onChange={onChange}
                  type="text"
                  name="phone"
                  placeholder={"Phone"}
                  className={inputStyle}
                />
              </div>
              <div className="flex flex-col">
                <label>Country</label>
                <input
                  value={formData.country}
                  onChange={onChange}
                  type="text"
                  name="country"
                  placeholder={"Country"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Province</label>
                <input
                  value={formData.province}
                  onChange={onChange}
                  type="text"
                  name="province"
                  placeholder={"Province"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>City</label>
                <input
                  value={formData.city}
                  onChange={onChange}
                  type="text"
                  name="city"
                  placeholder={"City"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Postal Code</label>
                <input
                  value={formData.postalCode}
                  onChange={onChange}
                  type="text"
                  name="postalCode"
                  placeholder={"Postal Code"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Address</label>
                <input
                  value={formData.address}
                  onChange={onChange}
                  type="text"
                  name="address"
                  placeholder={"Address"}
                  className={inputStyle}
                  maxLength={25}
                />
              </div>
              <div className="flex flex-col">
                <label>Company</label>
                <input
                  value={formData.company}
                  onChange={onChange}
                  type="text"
                  name="company"
                  placeholder={"Company"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Custom Code</label>
                <input
                  value={formData.customCode}
                  onChange={onChange}
                  type="text"
                  name="customCode"
                  placeholder={"Custom Code"}
                  className={inputStyle}
                  maxLength={15}
                />
              </div>
              <div className="flex flex-col">
                <label>Schedule Shipping</label>
                <select
                  name="scheduleId"
                  value={formData.scheduleId}
                  onChange={onChange}
                  className={inputStyle}
                >
                  {data?.data?.schedule?.map((dat) => (
                    <option value={dat.id}>{dat.title}</option>
                  ))}
                </select>
              </div>
            </div>

            <button
              onClick={update_profile}
              className="my-8 bg-themeBlue text-white font-medium sm:text-xl text-lg py-3 px-8 rounded-md w-full border border-themeBlue hover:bg-transparent hover:text-themeBlue"
            >
              Update
            </button>
          </div>
        )}
      </section>
    </>
  );
}
